import { AxiosResponse } from 'axios';

import { TaxableItem } from '@/components/modals/SubmitOrder/types';
import { Contact, InputContactInfo } from '@/controllers/ShippingAddress';
import { Axios, AxiosService } from '@/services/Axios';
import { ContactVm } from '@/types';

export type CalculatedTaxObject = { tax: number };
export interface TaxController {
  getTax(
    address: Contact | ContactVm | InputContactInfo,
    items: TaxableItem[],
    proposalId: string,
  ): Promise<AxiosResponse<CalculatedTaxObject>>;
}

export class TaxControllerClass implements TaxController {
  constructor(private APIService: AxiosService) {}

  public getTax(
    address: Contact | ContactVm | InputContactInfo,
    items: TaxableItem[],
    proposalId: string,
  ) {
    const { city, zipCode, state } = address;

    return this.APIService.post<CalculatedTaxObject>('/orders/calculate-order-tax/v2', {
      proposalId,
      city,
      zipCode,
      state,
      items,
    });
  }
}

export const TaxController = new TaxControllerClass(Axios);
